export default function Marquee({ text = "MADE TO STAND OUT · ONE SHOP · ENDLESS POSSIBILITIES · TORONTO CUSTOM · " }) {
  const items = Array(8).fill(text).join("");
  return (
    <div className="overflow-hidden border-y border-[#222] py-6 bg-black" data-testid="marquee">
      <div className="marquee-track whitespace-nowrap flex">
        <div className="font-display text-6xl md:text-8xl tracking-tight outline-text pr-12">
          {items}
        </div>
        <div className="font-display text-6xl md:text-8xl tracking-tight outline-text pr-12">
          {items}
        </div>
      </div>
    </div>
  );
}
